//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscSteps2(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M21 5H11V7H21V5Z" fill="currentColor" /><path d="M21 11H11V13H21V11Z" fill="currentColor" /><path d="M21 17H11V19H21V17Z" fill="currentColor" /><path d="M5.49004 10H6.63004V5.44L4.54004 6.32V7.42L5.49004 7V10Z" fill="currentColor" /><path d="M6.75 15.33C7.15 14.81 7.4 14.4 7.4 13.88C7.4 13.11 6.79 12.55 5.93 12.55C5.36 12.55 4.85 12.78 4.52 13.05V14.13C4.79 13.9 5.3 13.57 5.74 13.57C6.09 13.57 6.26 13.74 6.26 14.02C6.26 14.36 5.87 14.85 5.49 15.36L4.25 17H7.52V16.06H6.19L6.75 15.33Z" fill="currentColor" /></svg>;
}
export default IconMiscSteps2;